import { PayloadAction } from '@reduxjs/toolkit';
import { InsertSnapQuoteLineOutputWithInventory } from '@snap-types/queries/insert-snap-quote-line';

import { WritableQuoteBuilderStateType } from '../../types/state';
import { transformPartialQuoteLineWithDefaults } from '../utilities/transform-quote-line';

export function configuratorQuoteLineAdded(
  state: WritableQuoteBuilderStateType,
  action: PayloadAction<InsertSnapQuoteLineOutputWithInventory>,
) {
  const quoteLine = {
    ...transformPartialQuoteLineWithDefaults(action.payload, state),
    inventory: action.payload.inventory,
  };

  state.quoteLineUuids.splice(quoteLine.lineNumber - 1, 0, quoteLine.uuid);
  state.quoteLines[quoteLine.uuid] = quoteLine;

  state.dialog = null;
}
